// composables/useUploader.js
import { ref } from 'vue'
import { Snackbar, Dialog } from '@varlet/ui'
import { uploadApi } from '@/api'
import { assetUrl } from '@/utils/helpers'   // ✅ 新增

export function useUploader() {
  const files = ref([])
  const uploading = ref(false)

  const handleAfterRead = (file) => {
    file.state = 'loading'
    file.isPending = true
  }

  const onOversize = () => {
    Snackbar.warning('图片大小不能超过 2MB')
  }

  const handleBeforeRemove = async (file) => {
    if (file.isExisting) {
      const action = await Dialog({
        title: '确认删除',
        message: '确定要删除该图片吗？'
      })
      return action === 'confirm'
    }
    return true
  }

  const readFileAsBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.onload = (e) => resolve(e.target.result)
      reader.onerror = reject
      reader.readAsDataURL(file)
    })
  }

  const uploadFiles = async (type = 'style') => {
    const pendingFiles = files.value.filter(f => f.isPending && f.file)

    if (pendingFiles.length === 0) {
      return getImageUrls()
    }

    uploading.value = true

    try {
      for (const file of pendingFiles) {
        let base64 = file.dataURL
        if (!base64 && file.file) {
          base64 = await readFileAsBase64(file.file)
        }

        if (!base64) {
          file.state = 'error'
          continue
        }

        const data = await uploadApi.uploadImage(base64, type)

        if (data?.success) {
          file.url = data.path
          file.cover = data.path
          file.state = 'success'
          file.isPending = false
          file.isExisting = true
        } else {
          file.state = 'error'
          Snackbar.error(data?.msg || '上传失败')
        }
      }

      return getImageUrls()
    } catch (err) {
      Snackbar.error('上传失败: ' + err.message)
      throw err
    } finally {
      uploading.value = false
    }
  }

  const getImageUrls = () => {
    return files.value
      .filter(f => f.isExisting && f.state === 'success' && f.url)
      .map(f => f.url.trim())
      .filter(url => url)
  }

  const hasPending = () => {
    return files.value.some(f => f.isPending && f.file)
  }

  // ✅ 关键改动：存进来的相对路径，先转完整 URL 再放进 files
  const setExistingFiles = (urls) => {
    if (!urls || urls.length === 0) {
      files.value = []
      return
    }
    files.value = urls.map(url => {
      const fullUrl = assetUrl(url.trim())   // ← APK 里拼上域名
      return {
        url: fullUrl,
        cover: fullUrl,
        state: 'success',
        isExisting: true
      }
    })
  }

  const clearFiles = () => {
    files.value = []
  }

  return {
    files,
    uploading,
    handleAfterRead,
    onOversize,
    handleBeforeRemove,
    uploadFiles,
    getImageUrls,
    hasPending,
    setExistingFiles,
    clearFiles
  }
}